<template>
  <div>
    <es-exception v-if="!hasModule('DRMCH:DWNLD:DOWNLOAD')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <es-loader v-else-if="loading" style="margin: 1rem"/>
    <es-exception v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <es-profile-header>
        <template #profile-header>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="header-title has-text-weight-bold" >
                  Search Information
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #profile-overview>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ Date.now() | formatDateMMDDYYYYHHMM }}
                </div>
                <div class="column-subtitle">Search Date</div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ extractTotalCount }}
                </div>
                <div class="column-subtitle">Search Result</div>
              </div>
            </div>
          </div>
        </template>
      </es-profile-header>
      <div class="tabs-container">
        <div class="tabs no-bottom-border">
          <ul>
            <li class="is-active">
              <a>
                DOWNLOAD
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="document-container">
        <dm-download-options :parentPage.sync="parentPage"/>
        <div class="document" v-if="parentPage.showExtract" style="margin-top: 1rem">
          <div class="header">
            <es-header>
              <template #header>

                <div class="header-title" v-if="parentPage && parentPage.extractInfo && parentIndex">Extract File({{ ( (parentPage.extractInfo.length = parentIndex.length) ? 1 : parentPage.extractInfo.length - parentIndex.length) }})</div>
                <div class="header-title" v-else>Extract File(s)</div>
              </template>
              <template #actions>
                <ul>
                  <li class="p-narrow no-border">
                  </li>
                  <li class="p-narrow no-border">
                  </li>
                </ul>
              </template>
            </es-header>
          </div>
          <div class="content">
            <es-loader v-if="parentPage.loadingExtract === true"/>
            <table v-else class="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th title="Extract Date">
                    Extract Date
                  </th>
                  <th title="Match Type">
                    Match Type
                  </th>
                  <th title="Location Info">
                    Location Info
                  </th>
                  <th title="Match Status">
                    Match Status
                  </th>
                  <th title="School Year">
                    School Year
                  </th>
                  <th title="Record Count">
                    Record Count
                  </th>
                  <th title="Extract Name">
                    Extract Name
                  </th>
                  <th title="Extract Status">
                    Extract Status
                  </th>
                  <th title="Actions">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="parentPage.extractInfo && ((showParent && extract.parent)
                    || (showParent && !extract.parent)
                    || (!showParent && !extract.parent)
                    || parentPage.extractInfo.length === 1)"
                    v-for="extract in parentPage.extractInfo" :key="extract.identifier">
                  <td>
                    <div v-if="extract.extractDate">
                      <div  class="has-text-weight-bold">
                        {{ extract.extractDate | formatDateMMDDYYYY }}
                      </div>
                      <div class="has-text-grey-light">
                        {{ extract.extractDate | formatTime }}
                      </div>
                    </div>
                    <div v-else>
                      &nbsp;
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ mappedMatchType(parentPage.programs[0]) }}
                    </div>
                  </td>
                  <td>
                    <router-link v-if="extract.district && extract.district.location && extract.district != 'MULTIPLE'"
                    :to="{
                      name: 'DmDistrictInfoDetails',
                      params: { code: extract.district.code }}"
                      class="is-size-6 has-text-weight-bold"
                      >
                      {{ extract.district.location.name }}
                    </router-link>

                    <span class="has-text-grey-light" v-if="extract.district && extract.district != 'Multiple Districts'"> ({{ extract.district.code }})</span>
                    <span class="has-text-grey-light" v-else> {{ extract.districtCode }} </span>

                    <div class="is-italic has-text-grey-light" v-if="extract.school && extract.school != 'Multiple Schools'">
                      <router-link v-if="extract.school && extract.school.location"
                      :to="{
                        name: 'DmSchoolInfoDetails',
                        params: { districtCode: extract.school.districtCode,
                                schoolCode: extract.school.code }}">
                          {{ extract.school.location.name}}
                      </router-link>
                      {{ extract.school.code }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      Match
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ parentPage.schoolYear }}
                    </div>
                  </td>
                  <td class="table-action">
                    <div class="has-text-weight-bold">
                    {{ extract.processedCount }} of {{ extract.totalCount }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ extract.fileName }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold" v-if="extract.status">
                      {{ extract.status | statusDescription }}
                    </div>
                    <div class="has-text-weight-bold" v-else>
                      QUEUED
                    </div>
                  </td>
                  <td class="action">
                    <div v-if="extract.status === 3">
                      <a v-if="extract.fileId"
                        :href="buildSplitUrl(extract.fileId, extract.fileName)">
                        Download
                      </a>
                    </div>
                    <div v-else>
                      <a @click=" getRefresh">
                        Refresh
                      </a>
                    </div>
                  </td>
                </tr>
                <tr v-if="(!parentPage.extractInfo) && parentPage">
                  <td>
                    <div v-if="parentPage.extractDate">
                      <div  class="has-text-weight-bold">
                        {{ this.parentPage.extractDate | formatDateMMDDYYYY }}
                      </div>
                      <div class="has-text-grey-light">
                        {{ this.parentPage.extractDate | formatTime }}
                      </div>
                    </div>
                    <div v-else>
                      &nbsp;
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      QUEUED
                    </div>
                  </td>
                  <td>
                    QUEUED
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      QUEUED
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      QUEUED
                    </div>
                  </td>
                  <td class="table-action">
                    <div class="has-text-weight-bold">
                     of
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ parentPage.extractName }}{{ parentPage.extractNameExt }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      QUEUED
                    </div>
                  </td>
                  <td class="action">
                    <div>
                      <a @click=" getRefresh">
                        Refresh
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
  faFileDownload,
} from '@fortawesome/pro-regular-svg-icons';
import DmDownloadOptions from '@/components/DmDownloadOptions.vue';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsPager from '@/components/EsPager.vue';
import EsProfileHeader from '@/components/EsProfileHeader';
import EsSelect from '@/components/EsSelect.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import FieldLabels from '@/mixins/FieldLabels';
import moment from 'moment';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleRight,
  faFileDownload,
);

export default {
  mixins: [
    BreadcrumbsManager,
    FieldLabels,
    PermissionManager,
  ],
  components: {
    DmDownloadOptions,
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
    EsPager,
    EsProfileHeader,
    EsSelect,
  },
  props: {
    id: {
      type: String,
    },
    districtCodes: {
      type: Array,
      default: [],
    },
    programCodes: {
      type: Array,
      default: [],
    },
    schoolCodes: {
      type: Array,
    },
    schoolYear: {
      type: String,
    },
    totalCount: {
      type: Number,
    },
  },
  data() {
    return {
      parentPage: {
        url: 'directmatch/search/download',
        notSearch: false,
        showExtract: false,
        loading: false,
        loadingExtract: false,
        userId: null,
        userEmail: null,
        extractName: null,
        extractNameExt: null,
        extractStatus: null,
        downloadFileId: null,
        extractDate: null,
        studentId: this.id,
        districts: this.districtCodes,
        programs: this.programCodes,
        schools: this.getSchoolCodes(),
        districtSchools: this.schoolCodes,
        schoolYear: this.schoolYear,
        split: null,
        processedCount: 0,
        totalCount: 0,
        matchStatusDesc: null,
        district: null,
        school:null,
        extractInfo: null,
        parentFileName: null,
        downloadIds: [],
        downloadIdNames: [],
      },
      loading: null,
      loadingError: null,
      showParent: null,
      downloadAllFiles: true,
      parentIndex: [],
      extractTotalCount: this.totalCount,
    };
  },
  async created() {
    await this.onLoad();
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch' } },
      { text: 'Download Search Result', to: {} },
    ]);

    if (
      this.hasModule('DRMCH:DWNLD:DOWNLOAD')
      && this.programCodes.length === 1
      && this.districtCodes.length === 1
    ) {
      if (!this.totalCount){
        this.updateStudents();
      }
      this.parentPage.split = this.properties['DIRECTMATCH-SPLIT_BATCH_OPTION_FOR_EXTRACTS'];
      this.loadRecentExtract();
    } else {
      this.loadingError = true;
    }
  },
  computed: {
    ...mapGetters('lookups', [
      'indexProgramsNonDCX',
    ]),
    ...mapGetters({
      properties: 'propertiesModule/properties',
    }),
    extractCount() {
      return this.parentPage.extractInfo.length;
    },
    showDLLink() {
      return this.parentPage.extractInfo.every(extract => extract.status === 3)
    },
    getDistrictParams() {
      const params = {};
      params.districtCode = this.parentPage.districts.map(d => d.code);

      return params;
    },
    urlParams() {
      const params = {};

      params.pageNum = this.page ? this.page : undefined;
      params.id = this.id ? this.id : undefined;
      params.programCode = this.programCodes.length ? this.programCodes : undefined;
      params.districtCode = this.districtCodes.length ? this.districtCodes : undefined;
      params.schoolCode = this.schoolCodes.length ? this.getSchoolCodes() : undefined;
      params.schoolYear = this.schoolYear ? this.schoolYear : undefined;

      return params;
    },
    urlParamsForDownload() {
      let urlParamForDL = "extractFileName=SEARCH";

      if(this.id)
        urlParamForDL += "&studentId="+ this.id;

      if(this.programCodes.length)
        urlParamForDL += "&programs="+this.programCodes
        ;
      if(this.districtCodes.length)
        urlParamForDL += "&districts="+this.districtCodes;

      if(this.schoolCodes.length)
        urlParamForDL += "&schools="+this.getSchoolCodes();

      if(this.schoolYear)
        urlParamForDL += "&schoolYear="+this.schoolYear;

      return urlParamForDL;
    },
    hasViewParams() {
      return this.idInput || this.parentPage.districts.length || this.parentPage.schools.length
        || this.parentPage.programs.length || this.parentPage.schoolYearInput.length;
    }
  },
  methods: {
    ...mapActions('lookups', [
      'loadPrograms',
    ]),
    mappedMatchType(code) {
      return this.indexProgramsNonDCX.find(({ code }) => this.programCodes.includes(code)).description;
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'directMatch' } },
        { text: `Compare ${this.properties['SYSTEM_LABEL-NEARMATCH']}`, to: { } },
      ]);
      try {
        await Promise.all([
          this.loadPrograms(),
        ]);
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.messages.push(this.apiMsg);
        this.loadingError = true;
        this.hasError = true;
        this.showMessage();
      }
      this.loading = false;
    },
    async updateStudents() {
      try {
        this.loading = true;
        this.loadingError = false;

        const response = await this.getStudents();
        this.extractTotalCount = response.data.totalCount;
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    getStudents() {
      return axios.get('directmatch/search',
      {
        params: this.urlParams,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      });
    },
    getDistrict(code) {
      return axios.get(`/districts/${code}`);
    },
    getSchool(schoolCode) {
      var tmpDistrictCode;
      const splitSchoolCodes = [];
      if(this.schoolCodes.length > 1){
        for (let i = 0; i < this.schoolCodes.length; i += 1) {
          splitSchoolCodes.push(this.schoolCodes[i].split(/[:]+/));
          if(splitSchoolCodes[i][0] === schoolCode){
            tmpDistrictCode = splitSchoolCodes[i][1];
          }
        }
      } else {
        splitSchoolCodes.push(this.schoolCodes[0].split(/[:]+/));
        if(splitSchoolCodes[0][0] === schoolCode){
          tmpDistrictCode = splitSchoolCodes[0][1];
        }
      }
      return axios.get(`districts/${tmpDistrictCode}/schools/${schoolCode}`);
    },
    getSchoolCodes() {
      return this.schoolCodes.map(code => code.split(/[:]+/)[0]);
    },
    async downloadAll(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildAllUrl(extractName) {
      return `${axios.defaults.baseURL}directmatch/search/downloadall/${extractName}`;
    },
    buildSplitUrl(dlFileId, splitFileName) {
      return `${axios.defaults.baseURL}directmatch/search/download/${dlFileId}?extractFileName=${splitFileName}`;
    },
    async getRefresh(){
      return (this.parentPage.extractName) ? this.refreshExtract() : this.loadRecentExtract();
    },
    async refreshExtract() {
      try {
        this.parentPage.loadingExtract=true;
        const responses = await axios.get(`directmatch/search/extractstatus?extractFileName=${this.parentPage.extractName}`);
        this.parentPage.extractInfo = responses.data;

        this.parentPage.downloadFileId = this.parentPage.extractInfo[0].fileId;
        this.parentPage.processedCount = this.parentPage.extractInfo[0].processedCount;
        this.parentPage.totalCount = this.parentPage.extractInfo[0].totalCount;

        this.downloadAllFiles = true;

        this.parentPage.downloadIds = new Array(0);
        this.parentPage.downloadIdNames = new Array(0);
        this.parentIndex = new Array(0);

        const eInfo = this.parentPage.extractInfo;

        for (let i = 0; i < this.parentPage.extractInfo.length; i++) {

          if (i === 0) {
            this.parentPage.extractStatus = ""+this.parentPage.extractInfo[i].status;
            this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
          }

          this.showParent = !(this.parentPage.split === "LEA");

          if (!this.parentPage.extractInfo[i].parent)
            this.downloadAllFiles = this.downloadAllFiles && (this.parentPage.extractInfo[i].status === 3)

          if (this.parentPage.extractInfo[i].status === 3) {
            const inArray = (element) => element == this.parentPage.extractInfo[i].fileId;
            if (this.parentPage.downloadIds.findIndex(inArray) == -1) {
              this.parentPage.downloadIds.push(this.parentPage.extractInfo[i].fileId);
              this.parentPage.downloadIdNames.push(this.parentPage.extractInfo[i].fileName);
            }
          }
          if (this.parentPage.extractInfo[i].parent) {
            this.parentPage.parentFileName = this.parentPage.extractInfo[i].fileName;
            this.parentIndex.push(i);

          }


          if (this.parentIndex || this.parentIndex != null ) {
            if (this.downloadAllFiles && (this.parentPage.downloadIds.length > 0) && (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length))) {
              for(let pi = 0; pi < this.parentIndex.length; pi++){
                this.parentPage.extractInfo[pi].status = 3;
              }
            }
          }

          let dData = null;
          let sData = null;

          if(this.parentPage.extractInfo[i].districtCode === "MULTIPLE") {
            this.parentPage.extractInfo[i].district = "Multiple Districts";
          } else if(this.parentPage.extractInfo[i].districtCode) {
            try {
              const dcode = this.parentPage.extractInfo[i].district.code;

              this.getDistrict(dcode).then((responseD) => {
                dData = responseD.data;
              });
            } catch (error) {
              this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
              this.showNotification('danger', [this.apiMsg]);
            }
            eInfo[i].district = dData;
            this.parentPage.extractInfo = eInfo;
          } else {
            this.parentPage.extractInfo[i].district = "Multiple Districts";
            this.parentPage.extractInfo[i].districtCode = "MULTIPLE"
          }

          if(this.parentPage.extractInfo[i].schoolCode === "MULTIPLE") {
            this.parentPage.extractInfo[i].school = "Multiple Schools";
          } else if(this.parentPage.extractInfo[i].schoolCode) {
            try {
              const code = this.parentPage.extractInfo[i].schoolCode;
              this.getSchool(code).then((response) => {
                sData = response.data;
              });
            } catch (error) {
              this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
              this.showNotification('danger', [this.apiMsg]);
            }
            eInfo[i].school = sData;
            this.parentPage.extractInfo = eInfo;
          } else {
            this.parentPage.extractInfo[i].school = "Multiple Schools";
            this.parentPage.extractInfo[i].districtCode = "MULTIPLE"
          }

          if(!this.parentPage.extractInfo[i].processedCount) {
            this.parentPage.extractInfo[i].processedCount = 0;
          }

          if(!this.parentPage.extractInfo[i].totalCount) {
            this.parentPage.extractInfo[i].totalCount = 0;
          }
        }

      } catch (e) {
        console.log('exception: ' + e);

      } finally {
        this.parentPage.loadingExtract=false;
      }
      this.parentPage.showExtract = true;
    },
    async loadRecentExtract() {
      try {

        this.parentPage.loadingExtract=true;

        const responses = await axios.get(`directmatch/search/recentextractstatus?${this.urlParamsForDownload}`);
        if(responses.data) {
          this.parentPage.extractInfo = responses.data;
          this.parentPage.downloadFileId = this.parentPage.extractInfo[0].fileId;
          this.parentPage.processedCount = this.parentPage.extractInfo[0].processedCount;
          this.parentPage.totalCount = this.parentPage.extractInfo[0].totalCount;

          this.downloadAllFiles = true;

          this.parentPage.downloadIds = new Array(0);
          this.parentPage.downloadIdNames = new Array(0);
          this.parentIndex = new Array(0);

          for (let i = 0; i < this.parentPage.extractInfo.length; i++) {

            if (i === 0) {
              this.parentPage.extractStatus = ""+this.parentPage.extractInfo[i].status;
              this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
            }

            this.showParent = !(this.parentPage.split === "LEA");

            if (!this.parentPage.extractInfo[i].parent)
              this.downloadAllFiles = this.downloadAllFiles && (this.parentPage.extractInfo[i].status === 3)

            if (this.parentPage.extractInfo[i].status === 3) {
              const inArray = (element) => element == this.parentPage.extractInfo[i].fileId;
              if (this.parentPage.downloadIds.findIndex(inArray) == -1) {
                this.parentPage.downloadIds.push(this.parentPage.extractInfo[i].fileId);
                this.parentPage.downloadIdNames.push(this.parentPage.extractInfo[i].fileName);
              }
            }
            if (this.parentPage.extractInfo[i].parent) {
              this.parentPage.parentFileName = this.parentPage.extractInfo[i].fileName;
              this.parentIndex.push(i);

            }


            if (this.parentIndex || this.parentIndex != null ) {
              if (this.downloadAllFiles && (this.parentPage.downloadIds.length > 0) && (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length))) {
                for(let pi = 0; pi < this.parentIndex.length; pi++){
                  this.parentPage.extractInfo[pi].status = 3;
                }
              }
            }

            if(this.parentPage.extractInfo[i].districtCode === "MULTIPLE") {
              this.parentPage.extractInfo[i].district = "Multiple Districts";
            } else if(this.parentPage.extractInfo[i].districtCode) {
              try {
                const code = this.parentPage.extractInfo[i].districtCode;
                await this.getDistrict(code).then((response) => {
                  this.parentPage.extractInfo[i].district = response.data;
                });
              } catch (error) {
                this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
                this.showNotification('danger', [this.apiMsg]);
              }
            } else {
              this.parentPage.extractInfo[i].district = "Multiple Districts";
              this.parentPage.extractInfo[i].districtCode = "MULTIPLE"
            }

            if(this.parentPage.extractInfo[i].schoolCode === "MULTIPLE") {
              this.parentPage.extractInfo[i].school = "Multiple Schools";
            } else if(this.parentPage.extractInfo[i].schoolCode) {
              try {
                const code = this.parentPage.extractInfo[i].schoolCode;
                await this.getSchool(code).then((response) => {
                  this.parentPage.extractInfo[i].school = response.data;
                });
              } catch (error) {
                this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
                this.showNotification('danger', [this.apiMsg]);
              }
            } else {
              this.parentPage.extractInfo[i].school = "Multiple Schools";
              this.parentPage.extractInfo[i].districtCode = "MULTIPLE"
            }

            if(!this.parentPage.extractInfo[i].processedCount) {
              this.parentPage.extractInfo[i].processedCount = 0;
            }

            if(!this.parentPage.extractInfo[i].totalCount) {
              this.parentPage.extractInfo[i].totalCount = 0;
            }
          }
          this.parentPage.showExtract = true;
        } else {
          this.parentPage.showExtract = false;
        }

      } catch (e) {
        console.log("error: " + e)
      } finally {
        this.parentPage.loadingExtract=false;
      }
    },
  },
  filters: {
    statusDescription(value) {
      var valueStr = ""+value;
      var stat = "N/A";
      if (valueStr === "0") {
        stat = "PROCESSING";
      } else if (valueStr === "1") {
        stat = "PROCESSING";
      } else if (valueStr === "2") {
        stat = "INTERRUPTED";
      } else if (valueStr === "3") {
        stat = "COMPLETED";
      }
      return stat;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"
  @import "~bulma/sass/utilities/mixins"

  /deep/ .multi-dropdown-columns.columns
    .field
      .select
        width: 100%
        select
          width: 100%
    .column
      padding-right: 0
      .field
        padding-right: $column-gap
        border-right: 1px dashed #ccc
        @include until($tablet)
          border-right: none
    .column:last-child
      .field
        border-right: none

  .container-search
    padding: 1rem

  div.buttons
    margin-top: 10px
  .source-tag
    background-color: #f8cbad !important
    color: #666
</style>
